// @noflow
import { useReactiveVar } from '@apollo/client'
import React from 'react'

import { shippingCountryDataVar } from '@/services/apollo'

import { countryCodeToLocaleCurrency } from '@/utils/countryCodeHelper'

import RedeemDiscount from '@/components/pages/CheckoutPage/components/OrderSummary/components/RedeemDiscount/RedeemDiscount'

import ModalLayout from '../../layout'

const RedeemDiscountModal = ({
  data
}: {
  data: { getFutureBoxes: () => Promise<void> }
}): JSX.Element => {
  const { getFutureBoxes } = data
  const shippingCountryData = useReactiveVar(shippingCountryDataVar)
  const { locale, currency } = countryCodeToLocaleCurrency(
    shippingCountryData?.code || 'GB',
    shippingCountryData?.defaultLanguage || 'en'
  )
  return (
    <ModalLayout
      title={{
        text: 'resume_plan_card.add_discount',
        namespace: 'treatments_paused_page',
        margin: false
      }}
      backgroundColor="white"
    >
      <div style={{ marginTop: '1.6rem' }}>
        <RedeemDiscount
          namespace={'checkout'}
          currency={currency}
          locale={locale}
          totalSavedAmount={null}
          userType="user"
          getFutureBoxes={getFutureBoxes}
        />
      </div>
    </ModalLayout>
  )
}

export { RedeemDiscountModal }
